import React, {Component} from 'react';
import Waypoint from "react-waypoint";
import QuoteBlock from "../../QuoteBlock/QuoteBlock";
import TextBlock from "../../TextBlock/TextBlock";
import PhotoInfo from "../../PhotoInfo/PhotoInfo";
import food_drive from "../../../images/fooddrive.jpg";
import growingLogo from "../../../images/growing.svg";
import habitat from "../../../images/habitat.png";
import habitat2 from "../../../images/habitat-officers-build.png";
import unway from "../../../images/unway.jpg";
import meals from "../../../images/meals.jpg";
import packers from "../../../images/packers.jpg";
import volunteers1 from "../../../images/volunteers1.png";
import volunteers2 from "../../../images/volunteers2.png";
import volunteers3 from "../../../images/volunteers3.png";
import volunteers4 from "../../../images/volunteers4.png";
import volunteers5 from "../../../images/volunteers5.png";
import tree from "../../../images/tree.svg";
import fruitLogo from "../../../images/grapes.svg";
import "./Charity.css";

/**
 * Charity
 */
class Charity extends Component {

    /**
     * Default Props
     *
     * @type {{headerHeight: string}}
     */
    static defaultProps = {
        headerHeight: '112px'
    };

    /**
     * Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.enterCharityTop = this.enterCharityTop.bind(this);
        this.leaveCharityTop = this.leaveCharityTop.bind(this);
        this.enterCharityBottom = this.enterCharityBottom.bind(this);
        this.leaveCharityBottom = this.leaveCharityBottom.bind(this);
    }

    /**
     * Enter charity top
     *
     * @param event
     */
    enterCharityTop(event) {
        if (event.currentPosition === 'inside') {
            this.props.setHeader('THE FRUITS OF OUR LABOR', fruitLogo, 'Awards, new products and more', true);
        }
    }

    /**
     * Leave charity top
     *
     * @param event
     */
    leaveCharityTop(event) {
        if (event.currentPosition === 'above') {
            this.props.setHeader('GROWING BY GIVING', growingLogo, 'The charitable events and campaigns we supported this year', true);
        }

    }

    /**
     * Enter charity bottom
     *
     * @param event
     */
    enterCharityBottom(event) {
        if (event.currentPosition === 'inside') {
            this.props.setHeader('GROWING BY GIVING', growingLogo, 'The charitable events and campaigns we supported this year', true);
        }
    }

    /**
     * Leave charity bottom
     *
     * @param event
     */
    leaveCharityBottom(event) {
        if (event.currentPosition === 'above') {
            this.props.setHeader('A THRIVING CULTURE', tree, 'The fun happens year-round at Sargento', true);
        }
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {

        const {headerHeight} = this.props;

        return (
            <div className="page_padding charity">

                <Waypoint onEnter={this.enterCharityTop}
                          onLeave={this.leaveCharityTop}
                          topOffset={headerHeight}/>

                <div className="top_quote layout">
                    <QuoteBlock quote="We encourage volunteerism because it helps us appreciate others
              and gain new perspectives. The community is where it all begins. If
              we don’t have strong communities, we will not have strong businesses.”"
                                author="Louie Gentine"
                                source="CEO"
                    />
                </div>

                <div className="layout">
                    <div className="column">
                        <div className="trademark">
                            <TextBlock title="Touchdowns for Charity"
                                       text="Established in 2002, Touchdowns for Charity is our annual program with the Green Bay Packers to raise money for the Hunger Task Force in Milwaukee and Paul’s Pantry in Green Bay. Sargento is proud to show not only our partnership with the hometown team, but also our long-term commitment to addressing hunger issues in our communities. "/>
                        </div>

                        <div className="scale packers">
                            <img alt=""
                                 src={packers}/>
                        </div>

                        <TextBlock title="United Way Campaign"
                                   text="United Way is a charity committed to the communities it serves. Over the past five years, the Sargento family has donated more than $3 million to charities during United Way. And every year, we strive to top last year’s donation. An eye-popping 86% of our employees participated in the 2017 campaign, which helped us smash our previous records in 2017 by raising $1 million!"/>
                        <div className="statbubble">
                            <div className="info_circle">
                                <p>
                                    <span>$3 Million</span>
                                    <span>DONATED BY THE<br/>SARGENTO FAMILY<br/>Over the Past Five Years </span>
                                </p>
                            </div>
                        </div>

                        <TextBlock title="Habitat for Humanity"
                                   textObject={{
                                       text1: "Sargento has supported Habitat for Humanity in Milwaukee, Wis. for the past 25 years. In 1992, our first year of collaborating with Habitat, we provided the muscle to simultaneously build two homes in Milwaukee. Sargento was the first company to sponsor Milwaukee Habitat, a responsibility that inspired other companies to follow our lead.",
                                       text2: "Since then, we’ve played an active role in supporting the charity, both financially and with the volunteer labor to help provide safe, affordable housing for families in need. To mark our 25th anniversary with Milwaukee Habitat, our senior leaders spent the first day of our Blitz Build week framing our 28th home alongside the deserving homeowner.",
                                       text3: "In June of 2017, we completed construction on a Habitat Home right in our own backyard in Plymouth. We partnered with Habitat for Humanity Lakeside to build a home for a young mother and her two boys."
                                   }}/>

                        <div className="scale">
                            <img alt=""
                                 src={habitat}/>
                        </div>

                        <TextBlock title="Habitat for Humanity: Tampa Edition"
                                   text="In addition to the Habitat builds here at our homebase in Wisconsin, the Sargento Family extended its charitable footprint to the balmy shores of Tampa. Our Tampa Consumer Products Division Sales Team took on a home renovation project in 90-degree tropical heat, dedicating the Habitat for Humanity home to a deserving local family."/>

                        <div className="left_quote">
                            <QuoteBlock quote="I’ve always been passionate about volunteering and Habitat for Humanity is an organization near and dear to Sargento, so I thought, why not bring it down here to Tampa? As a remote team, it’s hard to find a group volunteer activity—this was a great fit.”"
                                        author="Katie Kirkpatrick"
                                        source="Category Insights Manager"/>
                        </div>

                        <div className="subtext">
                            <p>
                                Ten members of Team Sargento showed up and got to work putting the
                                finishing touches on a house for Candice and her four small children.
                                From sodding, to cabinetry, to scraping excess paint, the team made
                                the house a home. What took eight weeks to build, came down to
                                this last bit of muscle from Sargento.
                            </p>
                        </div>
                    </div>

                    <div className="column">
                        <div className="statbubble">          
                            <div className="info_circle">
                                <p>
                                    <span>$1,500</span>
                                    <span>DONATED FOR EVERY<br/>PACKERS TOUCHDOWN</span>
                                </p>
                            </div>
                        </div>
                        <div className="statbubble">      
                            <div className="info_circle">
                                <p>
                                    <span>39</span>
                                    <span>PACKERS TOUCHDOWNS<br/>IN 2017</span>
                                </p>
                            </div>
                        </div>
                        <div className="statbubble">      
                            <div className="info_circle right">
                                <p>
                                    <span>$1,300,000</span>
                                    <span>DONATED OVER 15 SEASONS</span>
                                </p>
                            </div>
                        </div>

                        <div className="scale">
                            <img alt=""
                                 src={unway}/>
                        </div>

                        <QuoteBlock quote="The Sargento family should be extremely proud of our support of the United Way. Most companies do not see this level of participation. It says a lot about who we are as a company and our generosity.”"
                                    author="Kerry Kremer"
                                    source="SVP of Manufacturing and Engineering, United Way 2017 Campaign Chair "/>

                        <div className="construction scale">
                            <img alt=""
                                 src={habitat2}/>
                        </div>

                        <QuoteBlock quote="I love Sargento! You all helped a lot. There was a lot to do out in the sun, and I thank you all. This will do a lot for me and give me some stability. It’s nice to know I now have something I can call my own.”"
                                    author="Paul Walker"
                                    source="Milwaukee Habitat Home Owner"/>
                        <div className="volunteers">
                            <img alt=""
                                 src={volunteers1}/>
                            <img alt=""
                                 src={volunteers2}/>
                        </div>
                    </div>
                </div>

                <div className="layout">
                    <div className="photo_desc">
                        <div className="gal_block">
                            <TextBlock title="Other Good Works"
                                       text="Besides our big campaigns with Touchdowns for Charity, the United Way and Habitat for Humanity, our family lends a helping hand in many smaller ways every day. Here are a few highlights:"/>
                        </div>
                        <PhotoInfo background={volunteers3}
                                   title="THE WELCOME TABLE"
                                   info="Weekly volunteer food drive held at a Plymouth church."/>
                        <PhotoInfo background={meals}
                                   title="MEALS ON WHEELS"
                                   info="Consumers Products Division Sales &amp; Marketing team made art and food during annual meeting."/>
                        <PhotoInfo background={volunteers4}
                                   title="MEALS BY Consumer Products Division"
                                   info="Once again, our sales team stepped up and served meals at the Salvation Army."/>
                        <PhotoInfo background={volunteers5}
                                   title="DEPARTMENT VOLUNTEER DAYS"
                                   info="Departments, including HR, IT, Innovation & Marketing and Engineering held separate volunteer days with United Way."/>
                        <PhotoInfo background={food_drive}
                                   title="DRIVE THROUGH FOOD DRIVE"
                                   info="We helped orchestrate the CBS 58 food drive at Miller Park, which generated 102,o00 lbs of food donations."/>
                    </div>
                </div>

                <Waypoint onEnter={this.enterCharityBottom}
                          onLeave={this.leaveCharityBottom}/>
            </div>
        )
    }
}

export default Charity;



// WEBPACK FOOTER //
// ./src/components/Pages/Charity/Charity.jsx